import { useResourceCategoriesQuery } from "@graphql/resources/ResourceCategories.g";
import { useMemo } from "react";

export interface CategoryOption {
  id: string;
  label: string;
}

/**
 * Hook to fetch and format category options for dropdowns
 * Returns alphabetically sorted list of top-level categories
 */
export const useCategoryOptions = () => {
  const categoriesQuery = useResourceCategoriesQuery({
    first: 100,
    parent_Isnull: true,
  });

  const categoryOptions = useMemo(() => {
    const categories =
      categoriesQuery.data?.resourceCategories?.edges
        ?.map((edge) => edge?.node)
        ?.filter(Boolean) || [];

    // Sort alphabetically by name
    const sortedCategories = [...categories].sort((a, b) => {
      const nameA = a?.name || "";
      const nameB = b?.name || "";
      return nameA.localeCompare(nameB);
    });

    const options: CategoryOption[] = [
      { id: "", label: "All Categories" },
      ...sortedCategories.map((category) => ({
        id: category?.id || "",
        label: category?.name || "",
      })),
    ];

    return options;
  }, [categoriesQuery.data]);

  return {
    categoryOptions,
    isLoading: categoriesQuery.isLoading,
    error: categoriesQuery.error,
  };
};
